import type { SVGProps } from "react";
export interface AnonymousIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AnonymousIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AnonymousIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.875 19a1.874 1.874 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m10 0a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m2.25 0a4.125 4.125 0 0 1-8.25 0q.001-.189.02-.375h-1.789q.018.186.02.375A4.125 4.125 0 1 1 7 14.875c1.281 0 2.423.586 3.179 1.5h3.641A4.125 4.125 0 0 1 21.125 19M13.093 1.837a3.38 3.38 0 0 1 3.451-.782c1.215.41 2.182 1.483 2.436 2.94l1.282 7.329q1.034.27 2.08.605L22 12.999l-.342 1.073a37 37 0 0 0-2.64-.74c-4.748-1.138-9.25-1.147-14.036 0a37 37 0 0 0-2.64.74 1.125 1.125 0 1 1-.686-2.143 40 40 0 0 1 2.081-.605L5.02 3.995l.056-.268c.32-1.32 1.242-2.287 2.38-2.672 1.225-.413 2.64-.125 3.645.98l.098.098c.508.462 1.223.429 1.702-.098zm9.25 10.092a1.125 1.125 0 0 1-.685 2.143zm-6.518-8.742c-.404-.137-.874-.062-1.26.361-1.315 1.448-3.44 1.539-4.857.273l-.274-.273c-.385-.423-.856-.498-1.26-.361-.363.122-.72.437-.881.959l-.058.237-1.12 6.407c3.976-.753 7.82-.75 11.77 0l-1.12-6.407c-.117-.665-.525-1.056-.94-1.196"
      />
    </svg>
  );
}
